import { __rest } from "tslib";
import React, { useState } from 'react';
import { Modal, Checkbox } from 'antd';
import { TongyongChenggongMian, TongyongShuomingMian, TongyongYiwenMian, TongyongCuowutishiMian, TongyongGuanbiMian, TongyongGuanbiXian } from '@sirius/icons';
import { testPathMatch } from '../utils/capi';
import { inEdm, isElectron, isWebWmEntry } from '../utils/cenv';
import { SIDE_BAR_WIDTH, TOOL_BAR_HEIGHT } from '../utils/constant';
import classnames from 'classnames';
import styles from './SiriusModal.module.scss';
const Icons = {
    info: React.createElement(TongyongShuomingMian, { className: styles.siInfo }),
    error: React.createElement(TongyongGuanbiMian, { className: styles.siError }),
    confirm: React.createElement(TongyongYiwenMian, { className: styles.siConfirm }),
    warning: React.createElement(TongyongCuowutishiMian, { className: styles.siWarning }),
    success: React.createElement(TongyongChenggongMian, { className: styles.siSuccess }),
};
export const modalProps = {
    isGlobal: false,
    cancelText: '取消',
    okText: '确定',
    centered: true,
    destroyOnClose: true,
    maskClosable: true,
    closeIcon: React.createElement(TongyongGuanbiXian, null),
    wrapClassName: `${!testPathMatch('/') ? styles.modalWrapGlobal : !isWebWmEntry() ? styles.modalWrap : ''}`,
    maskStyle: {
        background: 'rgba(0, 0, 0, 0.5)',
        left: `${!testPathMatch('/') ? 0 : !isWebWmEntry() ? SIDE_BAR_WIDTH : 0}px`,
        top: `${!testPathMatch('/') ? 0 : !inEdm() && !isElectron() ? TOOL_BAR_HEIGHT : 0}px`,
    },
    globalMaskStyle: { background: 'rgba(0, 0, 0, 0.5)', left: 0 },
};
const OriginModal = props => {
    const { children, isGlobal = false, maskStyle } = props, restProps = __rest(props, ["children", "isGlobal", "maskStyle"]);
    const _maskStyle = isGlobal ? modalProps.globalMaskStyle : modalProps.maskStyle;
    return (React.createElement(Modal, Object.assign({ getContainer: false }, modalProps, restProps, { maskStyle: Object.assign(Object.assign({}, _maskStyle), maskStyle) }), children));
};
export const SiriusHtmlModal = props => {
    const { children, isGlobal = false, wrapClassName, maskStyle } = props, restProps = __rest(props, ["children", "isGlobal", "wrapClassName", "maskStyle"]);
    const _maskStyle = isGlobal ? modalProps.globalMaskStyle : modalProps.maskStyle;
    return (React.createElement(Modal, Object.assign({ keyboard: false, getContainer: false, bodyStyle: { padding: 0, margin: 0 }, footer: null }, modalProps, restProps, { maskStyle: Object.assign(Object.assign({}, _maskStyle), maskStyle) }), children));
};
const SiriusModal = OriginModal;
const handleSiriusModal = (props, type) => {
    let isChecked = false;
    if (props.needCheckContent) {
        props.content = (React.createElement(ModalCheckContent, { onCheck: (checked) => {
                isChecked = checked;
            } }, props.content));
        if (props.onOk) {
            const onOk = props.onOk;
            props.onOk = async () => {
                await onOk(isChecked);
            };
        }
    }
    if (props.hideCancel) {
        return Modal[type](Object.assign(Object.assign(Object.assign({}, modalProps), { icon: React.createElement("i", { className: `icon ${type}-icon` }) }), props));
    }
    const _maskStyle = (props === null || props === void 0 ? void 0 : props.isGlobal) ? modalProps.globalMaskStyle : modalProps.maskStyle;
    return Modal.confirm(Object.assign(Object.assign(Object.assign({}, modalProps), { className: classnames(props.className, 'sirius-confirm'), icon: Icons[type], maskStyle: Object.assign({}, _maskStyle) }), props));
};
SiriusModal.info = (props) => {
    return handleSiriusModal(props, 'info');
};
SiriusModal.success = (props) => {
    return handleSiriusModal(props, 'success');
};
SiriusModal.error = (props) => {
    return handleSiriusModal(props, 'error');
};
SiriusModal.warning = (props) => {
    return handleSiriusModal(props, 'warning');
};
SiriusModal.confirm = (props) => {
    return handleSiriusModal(props, 'confirm');
};
const ModalCheckContent = ({ onCheck, children }) => {
    const [checked, setChecked] = useState(false);
    return (React.createElement("div", { className: styles.modalCheckContentWrap, onClick: () => {
            setChecked(b => !b);
            onCheck(!checked);
        } },
        React.createElement("div", { className: styles.checkboxWrap },
            React.createElement(Checkbox, { checked: checked })),
        React.createElement("div", { className: styles.contentWrap }, children)));
};
export default SiriusModal;
